"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function eqz(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0001 21C7.0295 21 3 16.9705 3 11.9999C3 7.02935 7.0295 3 12.0001 3C16.9706 3 21.0002 7.02935 21.0002 11.9999C21.0002 16.9705 16.9706 21 12.0001 21ZM7.13861 9.03843C7.13861 9.56692 9.31293 9.99525 11.995 9.99525C14.677 9.99525 16.8513 9.56692 16.8513 9.03843C16.8513 8.50994 14.677 8.08146 11.995 8.08146C9.31293 8.08146 7.13861 8.50994 7.13861 9.03843ZM11.995 12.911C9.31293 12.911 7.13861 12.4827 7.13861 11.9542C7.13861 11.4257 9.31293 10.9972 11.995 10.9972C14.677 10.9972 16.8513 11.4257 16.8513 11.9542C16.8513 12.4827 14.677 12.911 11.995 12.911ZM7.13867 14.9633C7.13867 15.4918 9.31299 15.9202 11.9951 15.9202C14.6771 15.9202 16.8514 15.4918 16.8514 14.9633C16.8514 14.4349 14.6771 14.0064 11.9951 14.0064C9.31299 14.0064 7.13867 14.4349 7.13867 14.9633Z", fill: color }));
}
exports["default"] = eqz;
//# sourceMappingURL=eqz.js.map